export default __webpack_public_path__ + "static/media/microsoft-powerpoint-seeklogo.com.fdaff410.svg";